import React, { useEffect, useState } from 'react';
import { useRoutes, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { routesConfig } from './protected';
import { AppDispatch } from '@/stores/store';
import { TeamService } from '@/service';
import { LastReviewStatus } from '@/service/team/type/responseTeam.d';
import { UserService } from '@/service';
import { user } from '@/modules';
import { message } from 'antd';
import { DisableModal } from '@/features';

export const AppRoutes = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const element = useRoutes(routesConfig);
  const [disableOpen, setDisableOpen] = useState(false);
  const [teamName, setTeamName] = useState('');

  useEffect(() => {
    InitializeRoutes();
  }, []);

  const fetchUserInfo = async () => {
    return await UserService.fetchUserInfo();
  };

  const InitializeRoutes = async () => {
    const responseUserInfo = await fetchUserInfo();

    if (responseUserInfo.code) {
      message.error(responseUserInfo.message || responseUserInfo.reason);
      return;
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'user_info', responseUserInfo.data);
    }

    //有值的话设置到redux上
    dispatch(
      user.actions.setUserInfo({
        data: responseUserInfo.data,
      })
    );

    if (localStorage.getItem('WEB_DEVELOP_TEST')) {
      return;
    }

    //卡页面的条件    teamId = 0 || status不为成功  都重定向到  /examine
    if (!Number(responseUserInfo.data.currentTeamId)) {
      navigate('/examine');
      return;
    }
    // 获取团队状态status= STATUS_DISABLE禁用;
    const response = await TeamService.getCurrentTeam({
      teamId: responseUserInfo.data.currentTeamId,
    });
    if (response.code) {
      navigate('/examine');
      return;
    }
    setTeamName(response.data.name || '');
    if (response.data.status === 'STATUS_DISABLE') {
      console.log(response, responseUserInfo, '获取团队状态status= STATUS_DISABLE禁用');
      setDisableOpen(true);
      return;
    }
    if (
      !response.data.lastReview?.status ||
      Object.values(LastReviewStatus)
        .filter((items) => items !== 'STATUS_APPROVED')
        .includes(response.data.lastReview?.status!)
    ) {
      navigate('/examine');
      return;
    }
  };

  if (localStorage.getItem('WEB_DEVELOP_TEST')) {
    return <>{element}</>;
  }

  return (
    <>
      <DisableModal teamName={teamName} open={disableOpen} />
      {element}
    </>
  );
};
